import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "userNameContainer" };
const _hoisted_2 = { class: "mb-0 fw-bold small-pointer-content" };
import { useStore } from "vuex";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccessAsPointerCard',
    setup(__props) {
        const store = useStore();
        const userName = computed(() => store.getters.getName);
        const cardPosition = computed(() => store.getters.getAccessAsPointerCardPosition);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ top: `${cardPosition.value.top}px`, left: `${cardPosition.value.left}px` }),
                class: _normalizeClass([cardPosition.value.top !== 0 && cardPosition.value.left !== 0 ? 'opacity-100' : 'opacity-0', 'd-flex gap-2  px-2 py-1 pointer-container align-items-center position-fixed'])
            }, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-0 small-pointer-content" }, "Acessando como:", -1)),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(userName.value), 1)
                ])
            ], 6));
        };
    }
});
